var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_4364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42908 6.8717H7.71288C8.03649 6.8717 8.29881 6.60938 8.29881 6.28577C8.29881 5.96215 8.03649 5.69983 7.71288 5.69983H4.42908C4.10546 5.69983 3.84314 5.96215 3.84314 6.28577C3.84314 6.60938 4.10546 6.8717 4.42908 6.8717Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42908 9.50439H7.71288C8.03649 9.50439 8.29881 9.24207 8.29881 8.91846C8.29881 8.59484 8.03649 8.33252 7.71288 8.33252H4.42908C4.10546 8.33252 3.84314 8.59484 3.84314 8.91846C3.84314 9.24207 4.10546 9.50439 4.42908 9.50439Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42908 12.1372H7.71288C8.03649 12.1372 8.29881 11.8749 8.29881 11.5513C8.29881 11.2277 8.03649 10.9653 7.71288 10.9653H4.42908C4.10546 10.9653 3.84314 11.2277 3.84314 11.5513C3.84314 11.8749 4.10546 12.1372 4.42908 12.1372Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5176 7.47568C13.8412 7.47568 14.1035 7.21336 14.1035 6.88975V2.34375C14.1035 1.05141 13.0521 0 11.7598 0H6.09835C4.80601 0 3.7546 1.05141 3.7546 2.34375V2.83696H3.24023C1.94789 2.83696 0.896484 3.88837 0.896484 5.18071V12.6562C0.896484 13.9486 1.94789 15 3.24023 15H8.90165C10.194 15 11.2454 13.9486 11.2454 12.6562V12.163H11.7598C13.052 12.163 14.1034 11.1117 14.1035 9.81952C14.1035 9.49591 13.8413 9.23355 13.5176 9.23353H13.5176C13.194 9.23353 12.9317 9.49582 12.9316 9.8194C12.9316 10.4655 12.4059 10.9912 11.7598 10.9912H11.2454V5.18071C11.2454 3.88837 10.194 2.83696 8.90162 2.83696H4.92647V2.34375C4.92647 1.69758 5.45218 1.17188 6.09835 1.17188H11.7598C12.4059 1.17188 12.9316 1.69758 12.9316 2.34375V6.88975C12.9316 7.21336 13.194 7.47568 13.5176 7.47568ZM8.90165 4.00884C9.54782 4.00884 10.0735 4.53454 10.0735 5.18071V12.6562C10.0735 13.3024 9.54782 13.8281 8.90165 13.8281H3.24023C2.59406 13.8281 2.06836 13.3024 2.06836 12.6562V5.18071C2.06836 4.53454 2.59406 4.00884 3.24023 4.00884H8.90165Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_4364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.accb216395d4dfd769b3f3a1a9299fa9.svg";
export { ForwardRef as ReactComponent };